import React from 'react';
import PropTypes from 'prop-types';

import { Table, Column } from 'fixed-data-table-2';
import _ from 'lodash';
import TextCell from '../../components/TextCell/TextCell';
import { DateType } from '../../containers/UIhelper/UIDateFormater';

import { useDispatch } from 'react-redux';
import actions from '../../actions/AlertsBurstActions';

const AlertsBurstSamples = (props, context) => {
  const { uiInfo, samples, selectedAlertSample, timeZone } = props;
  const dispatch = useDispatch();

  let pWidth = 0.395 * (uiInfo.pageWidth - 10);
  let pHeight = 0.494 * uiInfo.pageHeight;

  const handleRowClick = (e, rowIndex) => {
    const selectedItem = samples[rowIndex];
    dispatch(actions.selectBurstAlertSample(selectedItem));
  };

  const getRowClassName = (rowIndex) => {
    if (selectedAlertSample) {
      const rowItem = samples[rowIndex];
      // Samples have no unique id from the backend, so match the whole object
      // (same approach as the couple samples table) — comparing ids would make
      // `undefined === undefined` true and highlight every row.
      if (_.isEqual(selectedAlertSample, rowItem)) {
        return 'active-row';
      }
    }
  };

  return (
    <div className='samples-table'>
      <Table
        rowsCount={props.samples.length}
        width={pWidth}
        maxHeight={pHeight - 117}
        headerHeight={30}
        rowHeight={30}
        onRowClick={handleRowClick}
        rowClassNameGetter={getRowClassName}
      >
        <Column
          columnKey='time_stamp'
          header={context.t('time_stamp')}
          cell={
            <TextCell
              data={samples}
              field='time_stamp'
              additional={timeZone}
              dateType={DateType.DATE_AND_TIME_WITH_SECONDS}
            />
          }
          width={105}
          flexGrow={2}
        />
        <Column
          columnKey='threshold_rms'
          header={context.t('threshold_rms')}
          cell={<TextCell data={samples} field='threshold_rms' />}
          width={60}
          flexGrow={1}
        />
        <Column
          columnKey='event_rms'
          header={context.t('event_rms')}
          cell={<TextCell data={samples} field='event_rms' />}
          width={50}
          flexGrow={1}
        />
        <Column
          columnKey='noise_interval_min'
          header={context.t('noise_interval_min')}
          cell={<TextCell data={samples} field='noise_interval_min' />}
          width={95}
          flexGrow={1}
        />
        <Column
          columnKey='test_count'
          header={context.t('test_count')}
          cell={<TextCell data={samples} field='test_count' />}
          width={45}
          flexGrow={1}
        />
        <Column
          columnKey='alert_count'
          header={context.t('alert_count')}
          cell={<TextCell data={samples} field='alert_count' />}
          width={45}
          flexGrow={1}
        />
        <Column
          columnKey='sample_frequency_hz'
          header={context.t('sample_frequency_hz')}
          cell={<TextCell data={samples} field='sample_frequency_hz' />}
          width={65}
          flexGrow={1}
        />
      </Table>
    </div>
  );
};

AlertsBurstSamples.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default AlertsBurstSamples;
